<template>
    <div>
        <div class="row main-content">
            <div class="col-12">
                <div class="panel mb-1 rounded p-4 pb-5 mt-4 mb-5">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="title mb-4">{{ $t("apiDocs") }}</h3>
                        </div>
                        <div class="col-12 mb-4 col-lg-6 mb-lg-0 col-first">
                            <div class="api-title">Kontrola izvještaja</div>
                            <div class="api-desc">
                                Šalje se samo glavni finansijski izvještaj.
                            </div>
                            <div class="mb-1">
                                <div>URL:</div>
                                <code>POST https://kontrole-irfi.fia.ba/api/ratify</code>
                            </div>
                            <div class="mb-1">
                                <div>Headers:</div>
                                <code>Content-Type: multipart/form-data; boundary=...</code>
                            </div>
                            <div>
                                <div>Body (form-data):</div>
                                <div>
                                    <code>{ name: "", value: &lt;MFI_Glavni_Izvještaj.xlsx&gt; }</code>
                                </div>
                            </div>
                            <div class="mt-3">
                                <div class="mb-1">Responses (application/json):</div>
                                <div class="response-item mb-1">
                                    <span class="badge badge-success">Success</span>
                                    <span>Status: 200 OK</span>
                                    <span>Body:</span>
                                    <code>{ "Errors": [] }</code>
                                </div>
                                <div class="response-item">
                                    <span class="badge badge-danger">Error</span>
                                    <span>Status: 200 OK</span>
                                    <span>Body:</span>
                                    <code>{ "Errors": ["Opis greške"] }</code>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="api-title">Upload izvještaja</div>
                            <div class="api-desc">
                                <div>Šalju se obavezno:</div>
                                <div>
                                    <ul>
                                        <li>Glavni finansijski izvještaj - naziv fajla mora počinjati sa MFI_</li>
                                        <li>Bilješke uz finansijske izvještaje - naziv fajla mora počinjati sa BFI_</li>
                                    </ul>
                                </div>
                                <div class="mt-1">Dodatni (opcionalno):</div>
                                <div>
                                    <ul>
                                        <li>Godišnji izvještaj o poslovanju - naziv fajla mora počinjati sa GIP_</li>
                                        <li>Odluka o raspodjeli poslovnog rezultata - naziv fajla mora počinjati sa RPR_</li>
                                        <li>Odluka o utvrđivanju finansijskih izvještaja - naziv fajla mora počinjati sa UIF_</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="mb-1">
                                <div>URL:</div>
                                <code>POST https://api.fia.ba/api/FileTemplate/upload</code>
                            </div>
                            <div class="mb-1">
                                <div>Headers:</div>
                                <code>Content-Type: multipart/form-data; boundary=...</code>
                            </div>
                            <div>
                                <div>Body (form-data):</div>
                                <div>
                                    <code>
                                        { name: "files", value: &lt;MFI_Glavni_Izvještaj.xlsx&gt; }<br>
                                        { name: "files", value: &lt;BFI_Bilješke&gt; }<br>
                                        { name: "files", value: &lt;Dodatni...&gt; }
                                    </code>
                                </div>
                            </div>
                            <div class="mt-3">
                                <div class="mb-1">Responses (text/plain):</div>
                                <div class="response-item mb-1">
                                    <span class="badge badge-success">Success</span>
                                    <span>Status: 200 OK</span>
                                    <span>Body:</span>
                                    <code>&lt;prazno&gt;</code>
                                </div>
                                <div class="response-item">
                                    <span class="badge badge-danger">Error</span>
                                    <span>Status: 400 Bad Request</span>
                                    <span>Body:</span>
                                    <code>"Opis greške"</code>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    .main-content {
        padding: 0% 7%;
        max-width: 100%;
    }
    .panel {
        background-color: var(--light-color);
        box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        transition: transform .2s;
    }
    .title {
        font-size: 24px;
        color: var(--main-color);
    }
    .col-first {
        max-width: 450px;
    }
    .api-title {
        font-weight: 600;
        color: var(--main-color);
        font-size: 18px;
        margin-bottom: 0.75rem;
    }
    .api-desc {
        margin-bottom: 0.5rem;
    }
    .api-desc ul {
        margin: 0;
    }
    code {
        display: inline-block;
        padding: 4px 8px;
        background-color: rgba(169, 169, 169, 0.1);
        border: 1px solid rgba(169, 169, 169, 0.3);
        border-radius: 4px;
        font-size: 12px;
    }
    .response-item {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .badge {
        min-width: 45px;
    }
</style>
